export const environment = {
  production: false,
  // apiUrl: 'https://dev.backend.finqy.ai',
  apiUrl: 'https://uatlmsapi.banqmart.com',
  partnerBaseUrl: 'https://qappapi.finqy.ai/api/v1',
  authUrl: 'https://api-auth.finqy.ai/oauth/getAccesstoken',
};
 
